module.exports = __webpack_public_path__ + "media/images/icons/facilities/airco-ba1c60dc21035db210dbe78c8a684f78.svg";